import { Component } from '@angular/core';
import { IzzyAutomationRuleEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'Automation Rules') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-izzyautomationrule-form',
    templateUrl: './izzyautomationrule.form.component.html'
})
export class IzzyAutomationRuleFormComponent extends BaseFormComponent {
    public record!: IzzyAutomationRuleEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'automationSettings', sectionName: 'Automation Settings', isExpanded: true },
            { sectionKey: 'logicConfiguration', sectionName: 'Logic Configuration', isExpanded: true },
            { sectionKey: 'systemMetadata', sectionName: 'System Metadata', isExpanded: false }
        ]);
    }
}

